import Page from '../components/ui/Page';
import ContentLayout from '../layouts/ContentLayout';

const Feature = ({ title, body, image, reverse = false }) => (
  <div
    className={`flex flex-col items-center w-full mt-24 md:mt-32 ${
      reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'
    }`}
  >
    <div className="w-full px-10 py-2 lg:w-1/3">
      <h3 className="flex justify-center text-center">{title}</h3>
      <div className="px-3 py-1">{body}</div>
    </div>
    <div className="flex justify-start w-full px-10 py-2 lg:w-2/3">
      <div className="p-2 border rounded shadow-2xl">
        <img className="object-contain object-top" src={image} />
      </div>
    </div>
  </div>
);

const IndexPage = () => {
  return (
    <Page>
      <ContentLayout
        heading={
          <span className="block -mb-16 sm:-mt-10">
            So.
            <br />
            Many.
            <br />
            Features.
          </span>
        }
      >
        <Feature
          title="Drag to edit"
          body="Simply drag and move any item around to update it"
          image="/static/img/product/dragging.gif"
        />
        <Feature
          title="Shortcuts for quick actions"
          body={
            <>
              <span className="text-xs code">Opt</span> + click any item to duplicate it.{' '}
              <span className="text-xs code">Cmd</span> + click to mark it as done!
            </>
          }
          image="/static/img/product/shortcuts.gif"
          reverse
        />
        <Feature
          title="We’ve got colors"
          body="Use them to visually categorize your items"
          image="/static/img/product/colors.gif"
        />
        <Feature
          title="Set your milestones"
          body="Highlight key dates on your roadmap"
          image="/static/img/product/milestones.gif"
          reverse
        />
        <Feature
          title="Week, 2-Weeks, Month"
          body="View your roadmap on a scale of week, 2-week or a month at a time"
          image="/static/img/product/scale.gif"
        />
        <Feature
          title="And, if everything’s on fire..."
          body="Make it known!"
          image="/static/img/product/fire.gif"
          reverse
        />
      </ContentLayout>
    </Page>
  );
};

export default IndexPage;
